var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.drug?.cool
        ? _c("p", [
            _c("span", { staticClass: "icon icon-snowflake" }),
            _vm._v(" хладагент"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.details ?? [], function (d) {
        return d.int_value
          ? _c(
              "p",
              [
                d.alias === "order_rate" && +d.int_value !== 1
                  ? [
                      _vm._v("\n      коэфф. закупки "),
                      _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v(_vm._s(d.int_value)),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          "(В фактическое к-во\n      вносить\n      данные в пересчете на наше к-во таблеток!)"
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                d.alias === "oposit_order_rate"
                  ? [
                      _vm._v("\n      фасовка блистеров "),
                      _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v(_vm._s(d.int_value)),
                      ]),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          "(В фактическое\n      к-во\n      вносить данные в пересчете на наше к-во таблеток!)"
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.drug?.pack_set > 1
        ? _c("p", [
            _vm._v("комплект "),
            _c("span", { staticClass: "badge badge-info" }, [
              _vm._v(_vm._s(+_vm.drug?.pack_set)),
            ]),
            _vm._v(" зав.уп."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.drug?.pack_box_comment
        ? _c("p", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.drug.pack_box_comment)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.drug?.purchase_comment
        ? _c("p", { staticClass: "text-muted" }, [
            _vm._v(_vm._s(_vm.drug.purchase_comment)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.drug?.is_press_can
        ? _c("p", [
            _c(
              "span",
              { staticClass: "badge badge-danger" },
              [_c("v-icon", { attrs: { name: "spray-can" } })],
              1
            ),
            _vm._v(" аэрозоль под давлением\n  "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }